<div class="wrapper">
  <div
    class="progress-section flex flex-row justify-start items-start"
    >
    @for (field of fields; track field; let i = $index) {
      <div
        [class.currentQuestionNumber]="i <= currentIndex"
        class="flex-1 progress-indicator"
        >
        &nbsp;
      </div>
    }
  </div>
  <div class="action-section flex flex-row justify-between items-center px-[24px]">
    <div class="counter text-type-8">
      {{ currentIndex + 1 }}/{{ fields?.length }}
    </div>
    <mat-icon (click)="close()">close</mat-icon>
  </div>
  <div class="content-section flex flex-row justify-center items-center">
    <div class="question-container text-type-2">
      {{ currentQuestion.label }}
    </div>
    <hr class="vertical-hr">
    <div class="question-form-section flex flex-col justify-between">
      @if (type === 'generalQuestions') {
        <app-general-question-form
          [currentIndex]="currentIndex"
          [currentQuestion]="currentQuestion"
          [form]="form"
          [responseOptions]="responseOptions"
          class="question-form"
          />
      } @else {
        <app-frequency-question-form
          [currentIndex]="currentIndex"
          [currentQuestion]="currentQuestion"
          [form]="form"
          [frequency]="frequency"
          class="question-form"
          />
      }
      <app-question-action-section
        [currentIndex]="currentIndex"
        [fields]="fields"
        class="actions-section w-[528px]"
        />
    </div>

  </div>

</div>
